import QuestionnaireItem from './QuestionnaireItem';
import AutocompleteV2 from '../AutocompleteV2/AutocompleteV2';
import apiClient from '../../Services/NetteApiClient';
import { useState } from 'react';

export default function QuestionnaireAutocomplete(props) {
	const [items, setItems] = useState([]);

	const handleSearch = async value => {
		const { data } = await apiClient.get(
			`/questionnaire/questionnaire-search/fulltext?autocomplete_query=${value}`,
		);

		setItems(data);
	};

	const handleChange = value => {
		props.onChange && props.onChange(value);
	};

	return (
		<AutocompleteV2
			inputPlaceholder={props.placeholder || 'Vyberte dotazníky...'}
			items={items}
			onSearch={handleSearch}
			onChange={handleChange}
			itemTemplate={props => <QuestionnaireItem {...props} user={props.item} />}
		/>
	);
}
